/* eslint-disable  no-irregular-whitespace */
import { UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import imgSrc from './assets/icon.svg';
import * as styles from './styles.css';

interface ICPDAsideTrap {
  onClick?: () => void;
}

export const CPDAsideTrap: React.FC<ICPDAsideTrap> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <div onClick={onClick} className={styles['btn']}>
        <img className={styles['icon']} src={imgSrc} alt="" />
        <span className={styles['texts']}>
          <UIText1>Эксперт от Циана</UIText1>
          <UIText2 color="current_color">Помощь с поиском и гарантия безопасной сделки</UIText2>
        </span>
        <span className={styles['arrow']}>
          <IconActionChevronRight16 color="current_color" />
        </span>
      </div>
    </div>
  );
};
